var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Flex, getPaletteColor } from 'pcln-design-system';
/** @public */
var FlexShadow = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", "px;\n  background: linear-gradient(\n    ", ",\n    ", "\n  );\n  background-position: 0px ", "px;\n  background-repeat: no-repeat;\n  box-shadow: ", "px ", "px 0px 0px\n      ", ",\n    -", "px ", "px 0px 0px ", ";\n"], ["\n  border-radius: ", "px;\n  background: linear-gradient(\n    ", ",\n    ", "\n  );\n  background-position: 0px ", "px;\n  background-repeat: no-repeat;\n  box-shadow: ", "px ", "px 0px 0px\n      ", ",\n    -", "px ", "px 0px 0px ", ";\n"
    /** @public */
])), function (props) { return props.shadowOffsetX || 10; }, function (props) { return getPaletteColor(props.shadowColor || 'primary.light', 'base'); }, function (props) { return getPaletteColor(props.shadowColor || 'primary.light', 'base'); }, function (props) { return props.shadowOffsetY || 30; }, function (props) { return props.shadowOffsetX || 10; }, function (props) { return props.shadowOffsetY || 30; }, function (props) { return getPaletteColor(props.shadowColor || 'primary.light', 'base'); }, function (props) { return props.shadowOffsetX || 10; }, function (props) { return props.shadowOffsetY || 30; }, function (props) { return getPaletteColor(props.shadowColor || 'primary.light', 'base'); });
/** @public */
var HighlightedFlex = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React.createElement(FlexShadow, __assign({}, props), children);
};
/** @public */
export { HighlightedFlex };
var templateObject_1;
//# sourceMappingURL=HighlightedFlex.js.map